
      import { createComponent } from '@lit/react'
      import { type EventName } from '@lit/react'
      import * as React from 'react'

      import Component from '../../components/pager/pager.js'
      import type { DdsPaginationChangeEvent } from '../../events/events'
      export type { DdsPaginationChangeEvent } from '../../events/events'

      const tagName = 'dap-ds-pager'

      /**
 * `dap-ds-pager`
 * @summary A pager is a component that displays pagination controls.
 * @element dap-ds-pager
 * @title - Pager
 *
 * @event {{ action: string, pagination: { pageIndex: number, pageSize: number } }} dds-pagination-change - Event fired when the pagination changes
 *
 * @csspart base - The main pager container.
 * @csspart first - The first page button.
 * @csspart previous - The previous page button.
 * @csspart next - The next page button.
 * @csspart last - The last page button.
 * @csspart page-size - The page size select.
 * @csspart pager-button-first-base - The base of the first page button.
 * @csspart pager-button-first-content - The content of the first page button.
 * @csspart pager-button-previous-base - The base of the previous page button.
 * @csspart pager-button-previous-content - The content of the previous page button.
 * @csspart pager-button-next-base - The base of the next page button.
 * @csspart pager-button-next-content - The content of the next page button.
 * @csspart pager-button-last-base - The base of the last page button.
 * @csspart pager-button-last-content - The content of the last page button.
 * @csspart page-size-select-base - The base of the page size select.
 * @csspart page-size-select-trigger - The trigger of the page size select.
 * @csspart page-numbers - The container of the numbered page buttons (shown when showPageNumbers is 'true').
 * @csspart page-number - Each numbered page button.
 * @csspart page-number-active - The active (current) numbered page button.
 * @csspart page-number-base - The base of each numbered page button.
 * @csspart page-number-content - The content of each numbered page button.
 * @csspart page-info - The page info / total count text.
 *
 * @cssproperty --dds-pager-spacing-vertical - The vertical spacing of the pager (default: var(--dds-spacing-400))
 * @cssproperty --dds-pager-spacing-horizontal - The horizontal spacing of the pager (default: var(--dds-spacing-200))
 * @cssproperty --dds-pager-button-padding - The padding of the pager buttons (default: var(--dds-spacing-150))
 * @cssproperty --dds-pager-button-border-width - The border width of the pager buttons (default: var(--dds-border-width-base, 1px))
 * @cssproperty --dds-pager-button-border-color - The border color of the pager buttons (default: var(--dds-button-subtle-border-neutral-enabled))
 * @cssproperty --dds-pager-button-border-radius - The border radius of the pager buttons (default: var(--dds-radius-rounded))
 * @cssproperty --dds-pager-button-background - The background color of the pager buttons (default: var(--dds-button-subtle-background-neutral-enabled))
 * @cssproperty --dds-pager-button-font-size - The font size of the pager buttons (default: var(--dds-font-sm, 14px))
 * @cssproperty --dds-pager-button-font-weight - The font weight of the pager buttons (default: var(--dds-font-weight-bold, 700))
 */
      const reactWrapper = createComponent({
        tagName,
        elementClass: Component,
        react: React,
        events: {
          onDdsPaginationChange: 'dds-pagination-change' as EventName<DdsPaginationChangeEvent>
        },
        displayName: "DapDSPager"
      })

      export default reactWrapper
    